import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty, uniqueId } from 'lodash';
import filesize from "filesize";
import API from '../../../axios/api';
import axios from "axios";
import PhotoUpload from '../../../UI/PhotoUpload';
import { i18n } from '../../../translate/i18n';
import ModalEditPhoto from '../../../UI/PhotoEditor/ModalEditor';
import {
  Typography, IconButton, FormControl, TextField, Switch, FormControlLabel,
  FormHelperText,
} from '@mui/material';
import resizeFile from '../../../utils/imageResizer';

import {
  Delete,
  Close,
} from '@mui/icons-material';
import * as actions from "../../../store/actions";

import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../Forms/styles';

import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import PhotoBarUploading from '../../../UI/PhotoBarUploading/PhotoBarUploading';
import hasSiteAccess from '../../../utils/hasSiteAccess';
import { Tabs, Tab } from '@mui/material';
import CkEditor from '../../../UI/CkEditor';
import DOMPurify from 'dompurify';

const ModalParamEquipmentServicesQuestion = (props) => {
  const dispatch = useDispatch();

  const [isNewData, setIsNewData] = useState(true);

  const [name, setName] = useState("")
  const [description, setDescription] = useState("");

  const [nameError, setNameError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);

  const [weightError, setWeightError] = useState(false);
  const [weight, setWeight] = useState(1);

  const [tabValue, setTabValue] = useState(0);

  const [pictureEditMode, setPictureEditMode] = useState(false);
  const [modalPhoto, setModalPhoto] = useState();
  const [openModalAvatar, setOpenModalAvatar] = useState(false);
  const [profile, setProfile] = useState([])

  // selected values on autocomplete
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [searchTextGroup, setSearchTextGroup] = useState("")
  const [groupFormated, setGroupFormated] = useState({})
  const [groupError, setGroupError] = useState(false);
  const [profileError, setProfileError] = useState(false);

  const [commentFlag, setCommentFlag] = useState(false);
  const [fileFlag, setFileFlag] = useState(false);
  const [actionsWillHaveImpactOnEquipmentStatus, setActionsWillHaveImpactOnEquipmentStatus] = useState(true);

  function handleChangeTab(event, newValue) {
    setTabValue(newValue);
  }

  // get from redux
  const selectedAccess = useSelector(state => state.auth.selectedAccess);

  const loadingGroups = useSelector(state => state.statusVerificationItems.loading);
  const selectedSites = useSelector(state => state.sites.selectedSitesQuestions);
  const loading  = useSelector(state => state.questions.loading);

  // post to BE
  const postQuestions = (body) => dispatch(actions.postQuestions(body))
  const updateQuestions = (questionId, body) => dispatch(actions.updateQuestions(questionId, body))

  // FUNCTION TO FORMAT FIELD OF ACTIVITIES AND AREAS TYPES IN THE AUTOCOMPLETE
  const populateAllGroups = (groups) => {
    const dataFromRedux = groups
    const returnArray = []
    dataFromRedux.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setGroupFormated(returnArray)
  }


  // check if is newEntrance or editing
  useEffect(() => {
    populateAllGroups(props.allGroups)

    if (props.modalContent && props.modalContent.name) {
      setIsNewData(false)
      setSelectedGroup({ value: props.modalGroupContent._id, label: props.modalGroupContent.name })
      setName(props.modalContent.name);
      setDescription(props.modalContent.description);
      setProfile(props.modalContent.photo ? [props.modalContent.photo] : []);
      setCommentFlag(props.modalContent.commentFlag)
      setActionsWillHaveImpactOnEquipmentStatus(props.modalContent.actionsWillHaveImpactOnEquipmentStatus)
      setFileFlag(props.modalContent.fileFlag)
      setWeight(props.modalContent.weight)
    } else {
      setIsNewData(true)
      setSelectedGroup({ value: props.modalGroupContent._id, label: props.modalGroupContent.name })
    }
  }, [props.allGroups, props.modalContent, props.modalGroupContent._id, props.modalGroupContent.name])

  const handleSubmit = async e => {
    e.preventDefault();

    if (loading) { // prevent multiple questions to be posted
      return
    }

    let hasError = false;

    if (!weight || weight < 0) {
      setWeightError(true)
      hasError = true;
    }

    if (isEmpty(selectedGroup)) {
      setGroupError(true)
      hasError = true;
    }

    if (!name) {
      setNameError(true)
      hasError = true;
    }

    if (profile.length > 0 && profile[0]) {
      const notUploaded = profile.filter(fl => fl.uploaded === false)
      if (notUploaded.length > 0) {
        setProfileError(true)
        hasError = true;
      }
    }

    if (hasError) return;

    const body = {
      equipmentService: props.equipmentServiceId,
      groupId: selectedGroup.value,
      name: name.toUpperCase(),
      description,
      type: 'question',
      site: selectedSites[0]._id,
      commentFlag,
      fileFlag,
      actionsWillHaveImpactOnEquipmentStatus,
      weight
    };

    if (profile.length > 0 && profile[0] && (profile[0].id || profile[0]._id)) {
      body["photo"] = profile[0].id ? profile[0].id : profile[0]._id
    }

    if (isNewData) {
      postQuestions(body).then(result => {
        if (result !== 'error') {
          props.closeModal(result)
          dispatch(actions.updateEquipmentServiceInModel(result))
          props.setActualValue(result);
        }
      })
    } else {
      updateQuestions(props.modalContent._id, body).then(result => {
        if (result !== 'error') {
          props.closeModal(result)
          dispatch(actions.updateEquipmentServiceInModel(result))
          props.setActualValue(result);
        }
      })
    }
  }

  const handleInputChangeSelectorGroup = (text) => {
    setSearchTextGroup(text);
  }

  useEffect(() => {
    if (
      !isNewData
      && name.toUpperCase() === props.modalContent.name
      && description === props.modalContent.description
      && selectedGroup.value === props.modalContent.groupId
      && parseInt(weight) === props.modalContent.weight
      && commentFlag === props.modalContent.commentFlag
      && fileFlag === props.modalContent.fileFlag
      && actionsWillHaveImpactOnEquipmentStatus === props.modalContent.actionsWillHaveImpactOnEquipmentStatus
    ) {
      props.changesFunc(false)
    } else if (
      isNewData
      && name.toUpperCase() === ''
      && description === ''
      && selectedGroup.value === props.modalGroupContent._id
      && parseInt(weight) === 1
      && commentFlag === false
      && fileFlag === false
      && actionsWillHaveImpactOnEquipmentStatus === true
    ) {
      props.changesFunc(false)
    } else {
      props.changesFunc(true)
    }
  }, [name, description, selectedGroup, weight, selectedSites, commentFlag, fileFlag, actionsWillHaveImpactOnEquipmentStatus])

  const handleInputChangeGroup = selected => {
    setGroupError(false);
    setSelectedGroup(selected)
  }

  const handleUploadPhoto = async photo => {
    props.changesFunc(true);
    const uploadingFiles = photo.map(file => {
      return {
        file,
        name: file.name,
        readableSize: filesize(file.size),
        preview: URL.createObjectURL(file),
        fileType: file.type,
        uploaded: false,
        error: false,
        url: null
      }
    })

    setProfile(uploadingFiles)
    processUpload(uploadingFiles[0])
  }

  const handleCloseModalAvatar = (file) => {
    const uploadedFile = [];
    if (file) {
      uploadedFile.push({
        file,
        _id: uniqueId(),
        name: file.name,
        readableSize: filesize(file.size),
        preview: URL.createObjectURL(file),
        fileType: file.type,
        uploaded: false,
        error: false,
        url: null
      });
      setProfile(uploadedFile)
      processUpload(uploadedFile[0])
    }
    setOpenModalAvatar(false);
  }

  const updateFile = (id, data) => {
    setProfile(prevUf => {
      return prevUf.map(uf => id === uf._id ? { ...uf, ...data } : uf)
    })
  };

  const processUpload = async uploadedFile => {
    const newImage = await resizeFile(uploadedFile.file);
    const payloadToSign = {
      fileType: uploadedFile.fileType,
      name: uploadedFile.name
    };

    API.post("photos/signurl", { file: payloadToSign }).then(async signUrlRes => {
      axios.put(signUrlRes.data.url, newImage, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile._id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `profile/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType,
          source: 'web',
        }

        API.post("photos", body)
          .then(response => {
            setProfileError(false);
            updateFile(uploadedFile._id, {
              uploaded: true,
              _id: response.data._id,
              url: response.data.url
            });
          })
          .catch(() => {
            updateFile(uploadedFile._id, {
              error: true
            });
          });
      })
    })
  }

  const styles = {
    opacityContainer: {
      opacity: loadingGroups ? '0.3' : '1',
      position: 'relative'
    },
    deleteButton: {
      position: 'absolute',
      top: 5,
      right: 5,
    },
    avatarContainer: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: 14,
      paddingTop: 10,
      '.dropzone': {
        width: '100% !important',
      },
    },
    avatar: {
      maxWidth: 800,
      maxHeight: 600,
      minWidth: 400,
      minHeight: 300,
      marginTop: 20,
      cursor: 'pointer',
      borderRadius: 3,
    },
    tabs: {
      marginBottom: '18px',
    },
    helperText: {
      fontSize: 'medium',
      marginTop: '10px'
    },
  }

  return <>
    <ModalEditPhoto
      selectedFile={modalPhoto}
      open={openModalAvatar}
      onClose={handleCloseModalAvatar}
      title={i18n.t('modalEditPhotoModalEquipServiceQuest.title')}
    />
    <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>
      <DivFormTitle>
        <Typography variant='h6'>{`${isNewData ? i18n.t('typographyModalEquipServQuest.true') : i18n.t('typographyModalEquipServQuest.false')} ${i18n.t('typographyModalEquipServQuest.text')} ${selectedSites.length > 0 && `(${selectedSites[0].name})`}`}</Typography>
        {props.deleteButton && !isNewData &&
          <IconButton aria-label="delete" style={styles.deleteButton} size="large">
            <Delete
              onClick={() => props.handleDelete(props.modalContent)}
            />
          </IconButton>}
      </DivFormTitle>
      <>
        <FormControl variant="standard" fullWidth margin='normal' required>
          <Autocomplete
            loading={false} // sent to isLoading
            label={i18n.t('autocompleteModalEquipServQuest.group')}
            data={groupFormated} // sent to options
            onSelectValue={handleInputChangeGroup} // sent to onChange
            valueSelected={selectedGroup} // sent to value
            newSearchText={handleInputChangeSelectorGroup}
            name='group'
            hasError={groupError}
            disabled={isNewData || !hasSiteAccess(selectedAccess, selectedSites[0]._id)}
          />
        </FormControl>

        <FormControl variant="standard" fullWidth>
          <TextField
            autoFocus
            multiline
            rows={4}
            label={<h3 style={{ width: 'fit-content', marginTop: '4px'}}>{i18n.t('textFieldModalEquipServQuest.name')}</h3>}
            variant='outlined'
            name='name'
            onChange={event => { setNameError(false); return setName(event.target.value) }}
            value={name}
            margin='normal'
            error={nameError}
            InputLabelProps={{
              shrink: true,
            }}
            disabled={!hasSiteAccess(selectedAccess, selectedSites[0]._id)}
          />
        </FormControl>

        <Tabs
          value={tabValue}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChangeTab}
          aria-label="disabled tabs example"
          style={styles.tabs}
        >
          <Tab label={i18n.t('tabsChecklistQuestions.TabLabel1')} />
          <Tab label={i18n.t('tabsChecklistQuestions.TabLabel2')} />
          <Tab label={i18n.t('tabsChecklistQuestions.TabLabel3')} />
        </Tabs>

        {tabValue === 0 && <FormControl variant="standard" fullWidth>
          <Typography variant={'caption'} color={'#00000099'}>{i18n.t('textFieldModalEquipServQuest.description')}</Typography>
          <CkEditor
            data={description || ''}
            placeholder={''}
            onChange={ (_event, editor) => {
              const data = editor.getData();
              setDescription(DOMPurify.sanitize(data));
            } }
            onReady={(editor) => {
              editor.setData(description);
              editor.editing.view.change((writer) => {
              writer.setStyle(
                "min-height",
                "150px",
                editor.editing.view.document.getRoot(),
              );                    
              });
            }}
            disabled={!hasSiteAccess(selectedAccess, selectedSites[0]._id)}
          />
          <FormHelperText>{i18n.t('textFieldModalEquipServQuest.helperText')}</FormHelperText>
        </FormControl>}

        {tabValue === 1 && <div style={styles.avatarContainer}>
            <span>{i18n.t('switchModalEquipServQuest.labelDescriptiveImage')}</span>
            <PhotoUpload onUpload={handleUploadPhoto} photo={profile} enabled={hasSiteAccess(selectedAccess, selectedSites[0]._id)} fullWidth={true} />
            <PhotoBarUploading photo={profile} />
            {profileError ? <Typography style={{ color: "#f44336" }}>{i18n.t('typographyModalEquipServQuest.profileError')}</Typography> : null}
          </div>}

        {tabValue === 2 && <>
          <FormControl variant="standard">
            <TextField
              variant="standard"
              disabled={!hasSiteAccess(selectedAccess, selectedSites[0]._id)}
              type='number'
              label={i18n.t('switchModalEquipServQuest.labelWeight')}
              name='question-weight'
              onChange={event => { setWeightError(false); return setWeight(event.target.value) }}
              value={weight}
              error={weightError}
              helperText={weightError ? i18n.t('switchModalEquipServQuest.labelWeightError') : ''}
              margin='normal'
              InputProps={{ inputProps: { min: 0 } }} />
          </FormControl>
        <FormControl variant="standard" fullWidth>
          <FormControlLabel
            control={
              <Switch
                checked={commentFlag}
                onChange={e => setCommentFlag(e.target.checked)}
              />
            }
            label={i18n.t('switchModalEquipServQuest.label')}
          />
        </FormControl>
        <FormControl variant="standard" fullWidth>
          <FormControlLabel
            control={
              <Switch
                checked={fileFlag}
                onChange={e => setFileFlag(e.target.checked) }
              />
            }
            label={i18n.t('switchModalEquipServQuest.label3')}
          />
        </FormControl>
        <FormControl variant="standard" fullWidth>
          <FormControlLabel
            control={
              <Switch
                checked={actionsWillHaveImpactOnEquipmentStatus}
                onChange={e => setActionsWillHaveImpactOnEquipmentStatus(e.target.checked)}
              />
            }
            label={i18n.t('switchModalEquipServQuest.label2')}
          />
        </FormControl>
        </>}
      </>

      <DivSubmitButtons>
        <IconButton onClick={() => props.closeModal('question')} size="large"><Close fontSize='large' color='error' /></IconButton>
        {hasSiteAccess(selectedAccess, selectedSites[0]._id) && <IconButton type="submit" disabled={ loading } size="large"><DoneIconStyled fontSize='large' /></IconButton>}
      </DivSubmitButtons>
    </FormStyled>
  </>;
}

export default ModalParamEquipmentServicesQuestion;
